import { render, staticRenderFns } from "./BaseTabControlContentItem.vue?vue&type=template&id=9c483f66&scoped=true&"
import script from "./BaseTabControlContentItem.vue?vue&type=script&lang=js&"
export * from "./BaseTabControlContentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c483f66",
  null
  
)

export default component.exports